<template>
  <el-drawer
    :visible.sync="showMenu"
    :direction="direction"
    :with-header="false"
    class="width-drawer menuSetting2"
    :modalAppendToBody="false"
  >
    <div class="w-full flex flex-col justify-center items-start">
      <div
        class="w-full flex flex-row justify-between items-center py-3 px-4 shadow-md mb-3"
      >
        <p class="text-base">Menú</p>
        <button @click="closedMenu">
          <svg
            fill="currentColor"
            class="w-6 h-6 hover:text-[#fcdd07] text-[#999999]"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.004 23.087l7.08-7.081-7.07-7.071L8.929 7.02l7.067 7.069L23.084 7l1.912 1.913-7.089 7.093 7.075 7.077-1.912 1.913-7.074-7.073L8.917 25z"
            />
          </svg>
        </button>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo w-full"
      >
        <el-menu-item index="1">
          <router-link to="/" @click="closedMenu()">Inicio</router-link>
        </el-menu-item>
        <el-menu-item index="2" @click="closedMenu()">
          <router-link to="/quienes-somos">Curaduría</router-link>
        </el-menu-item>
        <el-menu-item index="3" @click="closedMenu()">
          <router-link to="/competencia">Competencia</router-link>
        </el-menu-item>
        <!-- <el-submenu index="3" @click="closedMenu()">
          <template slot="title"> Servicios </template>
          <el-submenu index="3-1">
            <template slot="title">
              <router-link
                to="/servicios?id=title&is=true"
                @click="closedMenu()"
              >
                Licencias Urbanísticas
              </router-link>
            </template>
            <el-menu-item index="3-1-1">
              <router-link
                to="/servicios?id=DefinicionClases&is=true"
                @click="closedMenu()"
              >
                Definición y clases de licencias urbanísticas
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-1-2">
              <router-link
                to="/servicios?id=LicenciasUrbanisticas&is=true"
                @click="closedMenu()"
              >
                Licencia de urbanización
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-1-3">
              <router-link
                to="/servicios?id=LicenciaParcelacion&is=true"
                @click="closedMenu()"
              >
                Licencia de parcelación
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-1-4">
              <router-link
                to="/servicios?id=LicenciaSubdivision&is=true"
                @click="closedMenu()"
              >
                Licencia de subdivision y sus modalidades
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-1-5">
              <router-link
                to="/servicios?id=LicenciaConstruccion&is=true"
                @click="closedMenu()"
              >
                Licencia de construcción y sus modalidades
              </router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3-2">
            <template slot="title">
              <router-link
                to="/servicios?id=OtrasActuaciones&is=false"
                @click="closedMenu()"
              >
                Otras actuaciones
              </router-link>
            </template>
            <el-menu-item index="3-2-1">
              <router-link
                to="/servicios?id=Ajustes&is=false"
                @click="closedMenu()"
              >
                Ajuste de cota de areas
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-2">
              <router-link
                to="/servicios?id=Concepto1&is=false"
                @click="closedMenu()"
              >
                Concepto de norma Urbanística
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-3">
              <router-link
                to="/servicios?id=Concepto2&is=false"
                @click="closedMenu()"
              >
                Concepto de uso del suelo
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-4">
              <router-link
                to="/servicios?id=Concepto3&is=false"
                @click="closedMenu()"
              >
                Copia certificada de planos
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-5">
              <router-link
                to="/servicios?id=Concepto4&is=false"
                @click="closedMenu()"
              >
                Aprobación de los planos en propiedad horizontal
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-6">
              <router-link
                to="/servicios?id=Concepto5&is=false"
                @click="closedMenu()"
              >
                Aprobación de piscinas
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2-6">
              <router-link
                to="/servicios?id=Concepto6&is=false"
                @click="closedMenu()"
              >
                Modificación de planos urbanísticos
              </router-link>
            </el-menu-item>
          </el-submenu>
        </el-submenu> -->
        <el-menu-item index="4" @click="closedMenu()">
          <router-link to="/requisitos">Requisitos</router-link>
        </el-menu-item>
        <el-submenu index="5" @click="closedMenu()">
          <template slot="title"> Consultas </template>
          <router-link to="/consultas?page=actosAdmin">
            <el-menu-item index="5-1" @click="closedMenu()">
              Actos administrativos (licencias) - Pronto
            </el-menu-item>
          </router-link>
          <router-link to="/consultas?page=consulteTramite">
            <el-menu-item index="5-2" @click="closedMenu()">
              Consulte su trámite - Pronto
            </el-menu-item>
          </router-link>
          <router-link to="/consultas?page=tarifas">
            <el-menu-item index="5-3" @click="closedMenu()">
              Tarifas
            </el-menu-item>
          </router-link>
          <router-link to="/consultas?page=Normatividad">
            <el-menu-item index="5-4" @click="closedMenu()">
              Normatividad
            </el-menu-item>
          </router-link>
          <router-link to="/consultas?page=cartografia">
            <el-menu-item index="5-5" @click="closedMenu()">
              Cartografía
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-menu-item index="6" @click="closedMenu()">
          <router-link to="/contacto">Contáctenos</router-link>
        </el-menu-item>
      </el-menu>
    </div>
  </el-drawer>
</template>

<script>
export default {
  created() {
    this.setMenu();
  },
  data() {
    return {
      drawer: false,
      direction: "rtl",
      activeIndex: "1",
    };
  },
  computed: {
    showMenu: {
      get() {
        return this.$store.state.showMenu;
      },
      set(newValue) {
        this.$store.commit("ACTIONS_MENU", newValue);
      },
    },
  },
  methods: {
    closedMenu() {
      this.showMenu = false;
    },
    setMenu() {
      if (this.$route.path) {
        switch (this.$route.path) {
          case "/":
            this.activeIndex = "1";
            break;
          case "/quienes-somos":
            this.activeIndex = "2";
            break;
          case "/servicios":
            this.activeIndex = "3";
            break;
          case "/requisitos":
            this.activeIndex = "4";
            break;
          case "/consultas":
            this.activeIndex = "5";
            break;
          case "/contacto":
            this.activeIndex = "6";
            break;
        }
      }
    },
  },
  watch: {
    $route() {
      this.setMenu();
    },
  },
};
</script>
<style scoped>
.width-drawer >>> .el-drawer__open .el-drawer.rtl {
  width: 410px !important;
}
.menuSetting2 >>> .el-menu.el-menu--horizontal {
  border-bottom: solid 1px transparent;
}
.menuSetting2 >>> .el-dropdown-menu__item,
.menuSetting2 >>> .el-menu-item,
.menuSetting2 >>> .el-submenu__title {
  font-size: 16px;
  padding: 0 12px;
}
.menuSetting2 >>> .el-menu-item,
.menuSetting2 >>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 40px;
  line-height: 40px;
  color: #999999 !important;
}
.menuSetting2 >>> .el-menu-item.is-active {
  border-bottom: 2px solid #fcdd07 !important;
  color: #999999 !important;
}
.menuSetting2 >>> .el-menu-item:focus {
  color: black !important;
}
.menuSetting2 >>> .el-menu-item:hover {
  color: black !important;
}
.menuSetting2
  >>> .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  background-color: transparent;
  border-bottom: 2px solid black !important;
  color: #999999;
}
.menuSetting2 >>> .el-menu-item:focus,
.menuSetting2 >>> .el-menu-item:hover,
.menuSetting2 >>> .el-submenu__title:hover,
.menuSetting2 >>> .el-submenu__title:focus {
  background-color: #eeeeee;
}
@media (max-width: 800px) {
  .width-drawer >>> .el-drawer__open .el-drawer.rtl {
    width: 100% !important;
  }
}
</style>
